import React from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Sparkles, Filter, Zap, PhoneCall, CalendarDays, CheckCircle2 } from "lucide-react";

const BENEFITS = [
  { icon: Sparkles, text: "Generador IA ilimitado: textos, imágenes y videos para CUALQUIER empresa o producto" },
  { icon: Filter, text: "Embudos con cuestionario inteligente que califican a tus prospectos automáticamente" },
  { icon: Zap, text: "Publicación automática en Instagram y Facebook con un clic" },
  { icon: PhoneCall, text: "Llamadas IA y minutos de inteligencia artificial para atender prospectos" },
];

export const RenalifeUpsell = () => {
  const navigate = useNavigate();
  return (
    <div data-testid="renalife-upsell" className="max-w-2xl mx-auto text-center py-10">
      <div className="w-16 h-16 rounded-full bg-[#FACC15]/15 border border-[#FACC15]/40 flex items-center justify-center mx-auto mb-5">
        <Lock className="text-[#FACC15]" size={28} />
      </div>
      <h1 className="font-renalife font-bold text-2xl sm:text-3xl text-[#F8FAF8]">
        Esta herramienta es de los <span className="text-[#FACC15]">paquetes MULTICONTACTOS</span>
      </h1>
      <p className="text-sm text-emerald-100/75 mt-3 max-w-lg mx-auto">
        Tu acceso RENALIFE ya incluye todo lo necesario para publicar: el <strong>Calendario de 15 días</strong>,
        <strong> TikTok con Avatar</strong> y tus <strong>Materiales listos</strong>. Si además quieres crear campañas
        personalizadas con IA, esto es lo que obtienes con un paquete:
      </p>
      <ul className="text-left max-w-md mx-auto mt-6 space-y-3">
        {BENEFITS.map((b) => (
          <li key={b.text} className="flex items-start gap-3 text-sm text-zinc-200">
            <CheckCircle2 size={17} className="text-[#FACC15] mt-0.5 shrink-0" /> {b.text}
          </li>
        ))}
      </ul>
      <div className="flex flex-wrap justify-center gap-3 mt-8">
        <button
          data-testid="upsell-view-plans"
          onClick={() => navigate("/dashboard/planes")}
          className="bg-[#FACC15] hover:bg-yellow-300 text-[#022C22] font-bold rounded-xl px-7 py-3.5 text-sm transition-colors"
        >
          Ver paquetes y precios
        </button>
        <button
          data-testid="upsell-back-calendar"
          onClick={() => navigate("/dashboard/calendario-renalife")}
          className="inline-flex items-center gap-2 border border-white/15 text-zinc-300 hover:bg-white/5 font-semibold rounded-xl px-6 py-3.5 text-sm transition-colors"
        >
          <CalendarDays size={16} /> Volver a mi campaña de 15 días
        </button>
      </div>
    </div>
  );
};

const RENALIFE_ALLOWED = [
  "/dashboard/academia",
  "/dashboard/materiales-renalife",
  "/dashboard/multinivel",
  "/dashboard/calendario-renalife",
  "/dashboard/tiktok-renalife",
  "/dashboard/prospectos",
  "/dashboard/perfil",
  "/dashboard/planes",
];

export const isRenalifeAllowedPath = (pathname) => {
  const clean = pathname.replace(/\/+$/, "") || "/dashboard";
  if (clean === "/dashboard") return true;
  return RENALIFE_ALLOWED.some((p) => clean === p || clean.startsWith(`${p}/`));
};
